import { TemplateTiles } from "./components/TemplateTiles"
import { Pagination } from "antd"
import { PlusOutlined, ReloadOutlined } from "@ant-design/icons"
import { Alert, Button, Card, Input, Select, Space, Table } from "antd"
import { useCallback } from "react"
import { Link } from "react-router-dom"
import { useRegulatorySession as useAuthContext } from "../../providers/regulatoryProvider"
import type { CatalogTemplate } from "../../types/regulatory"
import { catalogPermissions, catalogSourceLabel, catalogSourceNamespace } from "../../utils/regulatory"
import { allCatalogPages, regulatoryApi } from "../../utils/regulatoryApi"
import {
  CatalogFiltersBar,
  CatalogFrame,
  OwnershipTag,
  ResourceState,
  ReviewTag,
  ScopeTag,
} from "./components/CatalogUI"
import { dateValue } from "./format"
import { useCatalogFilters, useCatalogResource } from "./useCatalog"
export function ControlTemplatesPage() {
  const { user } = useAuthContext()
  const permissions = catalogPermissions(user)
  const { filters, page, update } = useCatalogFilters()
  const resource = useCatalogResource(
    useCallback((signal) => regulatoryApi.templates(filters, signal), [filters]),
  )
  const packs = useCatalogResource(
    useCallback((signal) => allCatalogPages(regulatoryApi.packs, signal), []),
  )
  return (
    <CatalogFrame
      title="Modèles de contrôle"
      extra={
        <>
          {permissions.manage && (
            <Link to="/regulatory/templates/new">
              <Button type="primary" icon={<PlusOutlined />}>
                Nouveau modèle
              </Button>
            </Link>
          )}
          <Button icon={<ReloadOutlined />} onClick={resource.reload}>
            Actualiser
          </Button>
        </>
      }
    >
      <CatalogFiltersBar filters={filters} update={update}>
        <Select
          aria-label="Paquet source"
          placeholder="Tous les paquets sources"
          allowClear
          loading={packs.loading}
          value={filters.packUuid}
          onChange={(value) => update({ packUuid: value })}
          options={packs.data?.map((pack) => ({ value: pack.uuid, label: pack.externalId }))}
          style={{ minWidth: 230 }}
        />
        <Input
          aria-label="Espace source"
          placeholder="Espace source"
          value={catalogSourceLabel(filters.namespace)}
          onChange={(event) => update({ namespace: catalogSourceNamespace(event.target.value) || undefined })}
          style={{ width: 170 }}
        />
      </CatalogFiltersBar>
      {packs.error && (
        <Alert
          type="warning"
          showIcon
          message="Les filtres de paquet source n’ont pas pu être chargés."
          description={packs.error.message}
          action={<Button onClick={packs.reload}>Réessayer</Button>}
        />
      )}
      <ResourceState {...resource} retry={resource.reload}>
        <TemplateTiles items={resource.data?.items ?? []} base="/regulatory/templates" />
        <Pagination
          current={page}
          pageSize={filters.limit}
          total={resource.data?.total}
          showSizeChanger
          pageSizeOptions={[25, 50, 100, 200]}
          showTotal={(total) => `${total} modèles`}
          onChange={(next, size) => update({ page: next, limit: size })}
        />
      </ResourceState>
    </CatalogFrame>
  )
}
